import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-users',
  templateUrl: './icon-users.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconUsersComponent {}
